module.exports = __webpack_public_path__ + "img/smm_ok1.d3e7bd8a.png";